// markets token & prices routes
export const GET_TOKEN_LIST_ROUTE = "/tokens";
export const GET_TOKEN_RESTRICTIONS_ROUTE = "/tokens/restrictions";
export const GET_WHIRLPOOL_POSITIONS_ROUTE = "/user/whirlpools";
export const GET_WHIRLPOOL_ROUTE = "/whirlpools";
export const FETCH_ORACLE_PRICES_ROUTE = "/prices";
//markets token & prices routes  - wallet header required

// markets loans routes
export const GET_LOANS_WITH_INFO_ROUTE = "/loans/info";
export const GET_LOAN_BY_ADDRESS_ROUTE = "/loans";
export const GET_HISTORICAL_LOANS_ROUTE = "/loans/historical";
export const ROUTE_TOGGLE_LOAN_POSITION = "/loans/toggle_position";
export const ROUTE_FETCH_PERMISSIONED_LOANS = "/permissioned_loans/fetch";
export const ROUTE_SET_REFINANCE_CONSTRAINT = "/loans/refinance_constraint";

// markets lending vaults routes
// markets earn vault routes (GET list; single vault: `${ROUTE_GET_EARN_VAULT_BY_ADDRESS}/${address}`)
export const ROUTE_GET_EARN_VAULTS = "/earn/vaults";
export const ROUTE_GET_EARN_VAULT_BY_ADDRESS = ROUTE_GET_EARN_VAULTS;
// markets earn routes - public
export const ROUTE_GET_EARN_QUEUE = "/earn/vaults/queue";
export const ROUTE_GET_EARN_ACTIVITY = "/earn/vaults/activity";
export const ROUTE_GET_EARN_STRATEGY_POSITIONS = "/earn/vaults/strategy-positions";
export const ROUTE_GET_EARN_VAULT_ALLOCATIONS = "/earn/vaults";
// markets earn routes - wallet header required
export const ROUTE_GET_EARN_VAULT_POSITION = "/earn/vaults/positions";
export const ROUTE_ACKNOWLEDGE_EARN_VAULT = "/earn/vaults/acknowledge";
export const ROUTE_GET_EARN_PORTFOLIO_POSITIONS = "/earn/portfolio/positions";
export const ROUTE_GET_EARN_PORTFOLIO_SUMMARY = "/earn/portfolio/summary";
export const ROUTE_GET_EARN_PORTFOLIO_EVENTS = "/earn/portfolio/events";
export const ROUTE_GET_EARN_PORTFOLIO_HISTORY = "/earn/portfolio/history";
export const ROUTE_GET_EARN_POSITION_CHART = "/earn/portfolio/chart";
export const ROUTE_GET_EARN_VAULT_HISTORY = "/earn/vaults/history";

export const ROUTE_GET_LENDING_VAULTS = "/lending_vaults/info";
export const ROUTE_GET_LENDING_VAULTS_HISTORY = "/lending_vaults/history";
export const ROUTE_GET_LENDING_VAULTS_UPDATE_HISTORY = "/lending_vaults/update_history";
export const ROUTE_GET_LENDING_VAULT_ALLOCATIONS = "/lending_vaults/allocation";
export const ROUTE_GET_LENDING_VAULT_ACTIVITY = "/lending_vaults/activity";
export const ROUTE_UPDATE_VAULT_METADATA = "/lending_vaults/metadata/update";
// markets lending vaults routes - wallet header required
export const ROUTE_GET_LENDING_USER_VAULT_POSITIONS = "/lending_vaults/user";
export const ROUTE_GET_USER_POSITION_DEPOSIT_SUMMARY = "/lending_vaults/deposit_summary";
export const ROUTE_GET_USER_EXTERNAL_REWARDS_PNL = "/lending_vaults/pnl/rewards";
// Returns whether the connected wallet (x-user-wallet header) is allowlisted for a
// specific vault via its wallet policy. Used to gate deposits on coming-soon vaults.
export const ROUTE_GET_VAULT_ACCESS = "/lending_vaults/access";

//markets routes
export const GET_MARKET_STATS_ROUTE = "/stats";
export const ROUTE_REFRESH_MARKET_TVL_STATS = "/tvl/refresh";
//markets routes - wallet header required
export const ROUTE_PORTFOLIO_REWARDS = "/portfolio/rewards";

//markets rates routes
export const GET_RATE_HISTORY_ROUTE = "/rates/history";
export const ROUTE_GET_PRINCIPAL_COLLATERAL_RATE_HISTORY = "/rates/principal_collateral/history";

//market quote routes
export const MARKET_QUOTE_ROUTE = "/quote";
export const MARKET_QUOTE_FOR_APY_ROUTE = "/quote/apy";
export const ROUTE_INCREASE_CREDIT_QUOTE = "/quote/increase_credit";
export const ROUTE_LOAN_SALE_QUOTE = "/quote/sell";
export const ROUTE_LOAN_SALE_QUOTE_BATCH = "/quote/sell/v2";
export const ROUTE_MERGE_PLAN_QUOTE = "/quote/merge_plan";
//market quote routes - wallet header required
export const GET_BEST_LOOP_QUOTE_ROUTE = "/quote/loop";
export const GET_MAX_QUOTE_ROUTE = "/quote/max";
export const GET_BEST_QUOTE_ROUTE = "/quote/best";

export const ROUTE_LOANS_PNL = "/loans/pnl";
export const ROUTE_LOANS_PNL_HISTORY = "/loans/pnl/history";

//advanced lending routes
export const GET_STRATEGY_INFO_ROUTE = "/strategy/infos";
export const GET_STRATEGY_SUMMARIES_ROUTE = "/strategy/summaries";
export const GET_MIN_PRINCIPAL_ROUTE = "/strategy/min_principal";
export const ROUTE_USER_STRATEGIES = "/user/strategies";
export const ROUTE_USER_LOANS = "/user/loans";
export const ROUTE_USER_VAULTS = "/user/vaults";

// market loop routes
export const GET_LOOP_VAULTS_INFO_ROUTE = "/loop/info";
export const ROUTE_GET_LATEST_COLLATERAL_YIELD_PCTS = "/loop/collateral_yield/latest/mints";

export const ROUTE_UPDATE_COLLATERAL_YIELD_UPDATE = "/loop/collateral_yield/update";

//oracle routes
export const ROUTE_FETCH_MARKET_INFORMATIONS = "/oracles/data/market_informations";
export const ROUT_FETCH_ORACLE_HISTORICAL_PRICES_ROUTE = "/oracles/prices/history";

// market external yield routes
export const ROUTE_GET_EXTERNAL_YIELD_INFO = "/external_yield/info";
export const ROUTE_GET_PAUSED_EXTERNAL_YIELD_SOURCES = "/external_yield/paused";

// ruby routes
export const ROUTE_GET_POINTS = "/points/rewards";
// ruby routes - wallet header required
export const ROUTE_GET_USER_REFERRAL_INFO_ROUTE = "/user/referral_info";
export const ROUTE_REFER_USER = "/user/refer";
export const ROUTE_GET_USER_POINTS_CALC = "/points/user/calc";
export const ROUTE_GET_USER_REFERRAL_POINTS_CALC = "/points/user/referrals";
export const ROUTE_GET_USER_TOTAL_BY_TYPE = "/points/user_total_by_type";
export const ROUTE_GET_USER_POINTS_RANK = "/points/user/rank";
export const ROUTE_VERIFY_AND_CLAIM_SEEKER_REWARDS = "/points/verify_and_claim_seeker_rewards";
// ruby routes - wallet header required
export const ROUTE_FETCH_COMMUNITY_MULTIPLIERS_FOR_WALLET = "/community_multipliers/user_wallet";

//Ruby external routes - wallet header required
export const ROUTE_VERIFY_TWITTER_FOLLOW = "/twitter/verify_follow";
export const ROUTE_FETCH_TWITTER_REQUEST_TOKEN = "/twitter/request_token";
export const ROUTE_FETCH_TWITTER_INFO = "/twitter/info";
export const ROUTE_VERIFY_DISCORD = "/discord/verify";
export const ROUTE_FETCH_DISCORD = "/discord";
export const ROUTE_ONBOARDING = "/onboarding";
export const ROUTE_WAITLIST_STATUS = "/waitlist/status";
export const ROUTE_WAITLIST_REGISTER = "/waitlist/register";

// transaction status route
export const TRANSACTIONS_STATUS_ROUTE = "/txns/status";

// Pandora transaction routes - Routes for handling complex multi-transaction operations
// that require orchestration of multiple instructions, some using proprietary packages. Used for loop unwind instructions, all require wallet header.

// pandora loop ixs routes
export const ROUTE_GET_SWAP_INSTRUCTIONS = `swap-instructions`;
export const ROUTE_GET_SWAP_ROUTES = `swap-routes`;
export const ROUTE_GET_ASYNC_SWAP_STATUS = `async_swap/status`;

export const ROUTE_GET_PARTNERS = "/ecosystem/partners";
export const ROUTE_GET_FARMING_INFOS = "/ecosystem/info";

export const ROUTE_GET_TIMELOCKS = "/timelock/list";

// vault disclosures (per-vault risks/audits/documentation; callers concatenate `/${address}`)
export const ROUTE_GET_VAULT_DISCLOSURES = "/vault_disclosures";
